<clr-datagrid [clrDgLoading]="loading">

  <clr-dg-column [clrDgField]="'date'" [clrDgSortOrder]="descSort">Datum</clr-dg-column>
  <clr-dg-column [clrDgField]="'movement_type'">Art
    <clr-dg-filter [clrDgFilter]="movementFilter">
      <div class="movement-filter">
        <label *ngFor="let opt of movementFilter.options" class="movement-filter__item">
          <input type="checkbox" [checked]="movementFilter.selected.has(opt.value)" (change)="movementFilter.toggle(opt.value)" />
          {{ opt.label }}
        </label>
      </div>
    </clr-dg-filter>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'order_id'">Vorgang</clr-dg-column>
  <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnr.<clr-dg-string-filter [clrDgStringFilter]="drawingFilter"></clr-dg-string-filter></clr-dg-column>
  <clr-dg-column [clrDgField]="'position'">Pos / Part</clr-dg-column>
  <clr-dg-column [clrDgField]="'number_of_pieces'">Stück</clr-dg-column>
  <clr-dg-column>Bestand</clr-dg-column>
  <clr-dg-column [clrDgField]="'serial_nr'">Seriennr.</clr-dg-column>
  <clr-dg-column [clrDgField]="'heat_nr'">Charge</clr-dg-column>
  <clr-dg-column>Mitarbeiter</clr-dg-column>
  <clr-dg-column>Dokument</clr-dg-column>

  <clr-dg-placeholder>Keine Lagerbewegungen für diesen Job.</clr-dg-placeholder>

  <clr-dg-row *clrDgItems="let entry of entries">
    <clr-dg-cell>{{ entry.date | date:'dd.MM.yyyy' }}</clr-dg-cell>
    <clr-dg-cell><span [ngClass]="movementClass(entry.movement_type)">{{ movementLabel(entry.movement_type) }}</span></clr-dg-cell>
    <ng-container [ngSwitch]="vorgangType(entry)">
      <clr-dg-cell *ngSwitchCase="'order'"     [routerLink]="['/order/details',     entry.project_id, entry.order_id]">
        <b>Order {{ entry.project_id }}.0002.{{ entry.order_id }}</b>
        <div *ngIf="entry.component_name" class="cell-subline">{{ entry.component_name }}</div>
      </clr-dg-cell>
      <clr-dg-cell *ngSwitchCase="'delivery'"  [routerLink]="['/delivery/details',  entry.project_id, entry.job_id, entry.delivery_id]">
        <b>Delivery {{ entry.project_id }}.0004.{{ entry.delivery_id }}</b>
        <div *ngIf="entry.component_name" class="cell-subline">{{ entry.component_name }}</div>
      </clr-dg-cell>
      <clr-dg-cell *ngSwitchCase="'transport'" [routerLink]="['/transport/details', entry.project_id, entry.job_id, entry.transport_id, entry.order_id]">
        <b>Transport {{ entry.project_id }}.0005.{{ entry.transport_id }}</b>
        <div *ngIf="entry.component_name" class="cell-subline">{{ entry.component_name }}</div>
      </clr-dg-cell>
      <clr-dg-cell *ngSwitchCase="'job'" [routerLink]="['/job/details', entry.project_id, entry.job_id]">
        <b>Job {{ entry.project_id }}.0001.{{ entry.job_id }}</b>
        <div *ngIf="entry.component_name" class="cell-subline">{{ entry.component_name }}</div>
      </clr-dg-cell>
      <clr-dg-cell *ngSwitchCase="'component'" [routerLink]="['/component/details', entry.technical_drawing]">
        <b>Komponente {{ entry.technical_drawing }}</b>
        <div *ngIf="entry.component_name" class="cell-subline">{{ entry.component_name }}</div>
      </clr-dg-cell>
      <clr-dg-cell *ngSwitchDefault>—</clr-dg-cell>
    </ng-container>
    <clr-dg-cell [routerLink]="entry.technical_drawing ? ['/component/details', entry.technical_drawing] : null">{{ entry.technical_drawing || '—' }}</clr-dg-cell>
    <clr-dg-cell>{{ entry.position_label || entry.position }} / {{ entry.part }}</clr-dg-cell>
    <clr-dg-cell class="cell-right"><b [ngClass]="pieceClass(entry.movement_type)">{{ pieceSign(entry.movement_type) }}{{ entry.number_of_pieces }}</b></clr-dg-cell>
    <clr-dg-cell class="cell-right">{{ balanceFor(entry) ?? '—' }}</clr-dg-cell>
    <clr-dg-cell>{{ entry.serial_nr || '—' }}</clr-dg-cell>
    <clr-dg-cell>{{ entry.heat_nr || '—' }}</clr-dg-cell>
    <clr-dg-cell>{{ entry.firstname }} {{ entry.lastname }}</clr-dg-cell>
    <clr-dg-cell>
      <button *ngIf="entry.file_id" class="btn btn-sm btn-link pdf-btn" (click)="openPdf(entry.file_id, entry.file_description)">
        <cds-icon shape="file" class="pdf-icon"></cds-icon><span class="pdf-name">{{ entry.file_description || 'Dokument' }}</span>
      </button>
      <span *ngIf="!entry.file_id">—</span>
    </clr-dg-cell>
  </clr-dg-row>

  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="25">
      <clr-dg-page-size [clrPageSizeOptions]="[25, 50, 100]">Einträge pro Seite</clr-dg-page-size>
      {{ pagination.firstItem + 1 }} – {{ pagination.lastItem + 1 }} von {{ pagination.totalItems }} Bewegung(en)
    </clr-dg-pagination>
  </clr-dg-footer>

</clr-datagrid>

<clr-modal *ngIf="showPdf" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false" clrModalSize="lg">
  <h3 class="modal-title">{{ modalContent }}</h3>
  <div class="modal-body">
    <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
  </div>
</clr-modal>
